<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dispute-drop border rounded mt-2" },
    [
      _c(
        "app-collapse",
        [
          _c(
            "app-collapse-item",
            { attrs: { title: _vm.$t("disputeStatus.DisputeDetails") } },
            [
              _vm.adOrderDispute && _vm.adOrderDispute.id
                ? _c("div", [
                    _c("div", { staticClass: "row mb-1" }, [
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("disputeStatus.DisputeRaisedBy(Buyer)")
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-amt no-wrap" }, [
                          _vm._v(
                            " " + _vm._s(_vm.adOrderDispute.userName) + " "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mb-1" }, [
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "disputeStatus.DisputeRaisedBy(CounterParty)"
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-amt no-wrap" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.adOrderDispute.counterPartyUserName) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mb-1" }, [
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("disputeStatus.DisputeReasonT")) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-amt no-wrap" }, [
                          _vm._v(" " + _vm._s(_vm.adOrderDispute.reason) + " "),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mb-2" }, [
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("disputeStatus.Description")) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c(
                          "div",
                          { staticClass: "profile-amt no-wrap de-sc" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.adOrderDispute.disputeDesc) + " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mb-2" }, [
                      _vm.adOrderDispute && _vm.adOrderDispute.resolution
                        ? _c("div", { staticClass: "col-md-6 pl-d" }, [
                            _c("div", { staticClass: "profile-text" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("disputeStatus.Solution")) +
                                  " "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c(
                          "div",
                          { staticClass: "profile-amt no-wrap de-sc" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.adOrderDispute.resolution) + " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mb-2" }, [
                      _c("div", { staticClass: "col-md-12 pl-d" }, [
                        _c("div", { staticClass: "profile-text proof-text" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("disputeStatus.Proof")) + " "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mb-2" }, [
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-text" }, [
                          _vm._v(_vm._s(_vm.$t("disputeStatus.Payment"))),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c(
                          "div",
                          { staticClass: "profile-amt no-wrap" },
                          [
                            _vm.adOrderDispute.proofs.paymentTxDocUrl &&
                            _vm.adOrderDispute.paymentTxDocUrlType === "image"
                              ? _c("JPG", {
                                  staticClass: "pointer",
                                  attrs: {
                                    src: _vm.adOrderDispute.proofs
                                      .paymentTxDocUrl,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showImage(
                                        true,
                                        _vm.adOrderDispute.proofs
                                          .paymentTxDocUrl,
                                        "image"
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.adOrderDispute.paymentTxDocUrlType === "pdf"
                              ? _c("PDF", {
                                  staticClass: "pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showImage(
                                        true,
                                        _vm.adOrderDispute.proofs
                                          .paymentTxDocUrl,
                                        "pdf"
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mb-2" }, [
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("disputeStatus.statement")) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c(
                          "div",
                          { staticClass: "profile-amt no-wrap" },
                          [
                            _c("PDF", {
                              staticClass: "pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.showImage(
                                    true,
                                    _vm.adOrderDispute.proofs
                                      .paymentTxBankStatementDocUrl,
                                    "pdf"
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mb-2" }, [
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c("div", { staticClass: "profile-text" }, [
                          _vm._v(_vm._s(_vm.$t("disputeStatus.video"))),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-md-6 pl-d" }, [
                        _c(
                          "div",
                          { staticClass: "profile-amt no-wrap" },
                          [
                            _vm.adOrderDispute.proofs.paymentTxAccountVideoUrl
                              ? _c("MP4", {
                                  staticClass: "pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showImage(
                                        true,
                                        _vm.adOrderDispute.proofs
                                          .paymentTxAccountVideoUrl,
                                        "video"
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c("ImagePreview", {
        attrs: {
          showPop: _vm.showDocumentPreviewModal,
          onModalHidden: _vm.showImage,
          url: _vm.url,
          documentType: _vm.type,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/dispute/DisputeDetails.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import core_components_app_collapse_AppCollapse_vue from '@core/components/app-collapse/AppCollapse.vue';
import core_components_app_collapse_AppCollapseItem_vue from '@core/components/app-collapse/AppCollapseItem.vue';
import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_mp4_svg from '@/assets/rashi-coin/mp4.svg';
import assets_rashi_coin_jpg_svg from '@/assets/rashi-coin/jpg.svg';
import assets_rashi_coin_pdf_svg from '@/assets/rashi-coin/pdf.svg';
import layouts_components_ImagePreview_vue from '@/layouts/components/ImagePreview.vue';
import layouts_components_VideoPreview_vue from '@/layouts/components/VideoPreview.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









export default ({
  render,
  staticRenderFns,
  components: {
    AppCollapse: core_components_app_collapse_AppCollapse_vue,
    AppCollapseItem: core_components_app_collapse_AppCollapseItem_vue,
    MP4: assets_rashi_coin_mp4_svg,
    JPG: assets_rashi_coin_jpg_svg,
    PDF: assets_rashi_coin_pdf_svg,
    ImagePreview: layouts_components_ImagePreview_vue,
    VideoPreview: layouts_components_VideoPreview_vue,
    BImg: bootstrapvue["BImg"]
  },
  props: {
    adOrderDispute: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDocumentPreviewModal: false,
      url: "",
      type: ""
    };
  },
  methods: {
    showImage(flag, url, type) {
      this.showDocumentPreviewModal = flag;
      if (flag) {
        this.url = url;
        this.type = type;
      } else {
        this.url = "";
        this.type = "";
      }
    }
  }
});

//# sourceURL=webpack:///./src/@core/components/dispute/DisputeDetails.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.profile-text {
  color: #686e7d;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.profile-amt {
  display: flex;
  justify-content: flex-end;
  color: var(--1e2329);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.profile-amt-green {
  display: flex;
  justify-content: flex-end;
  color: #8dc540;
  font-size: 21px;
  font-weight: 700;
  line-height: 32px;
}
.payment-show {
  display: flex;
  align-items: center;
}
.vertical-red-line {
  display: inline-block;
  width: 2px;
  height: 12px;
  /* border: 2px solid #f7984a; */
  /* background: #f7984a; */
}
[dir] .vertical-red-line {
  margin: 0px 5px -2px 5px;
  border-radius: 4px;
}
.payment-method {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 600;
  line-height: 24px;
}
[dir=ltr] .copy_icon {
  margin-left: 6px;
}
[dir=rtl] .copy_icon {
  margin-right: 6px;
}
.copy_icon path {
  fill: #636363;
}
[dir] .dispute-drop {
  border-radius: 4px;
}
.dispute_image_preview {
  max-height: 50px;
  max-width: 100%;
}
[dir] .dispute-drop {
  border-radius: 4px;
}
.dispute-drop .proof-text {
  color: var(--text-black-color) !important;
}
.dispute-drop .collapse-title {
  color: var(--text-black-color) !important;
  font-size: 16px;
}
.de-w {
  width: 50%;
}
[dir] .de-sc {
  text-align: end;
}
@media (max-width: 667px) {
[dir=ltr] .pl-d {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
[dir=rtl] .pl-d {
    padding-right: 0 !important;
    padding-left: 0 !important;
}
[dir] .pl-d .de-sc {
    text-align: start;
}
.pl-d .profile-amt {
    display: grid;
    justify-content: start;
}
[dir] .pl-d .profile-amt {
    margin-top: 5px;
}
}
</style>
